<script lang="ts" setup>
import SectionPackagesError from '@/components/SectionPackagesError.vue';

import { hideInitialLoader } from '@/helpers/utils';

const error = ref<Error | null>(null);

// Capture any errors from child components
onErrorCaptured((err: Error) => {
  error.value = err;

  // eslint-disable-next-line no-console
  console.error('Error captured in SuspenseWithError:', err);

  // Prevent error from propagating further
  return false;
});
</script>

<template>
  <Suspense @resolve="hideInitialLoader">
    <template #default>
      <slot v-if="!error" />
      <SectionPackagesError v-else />
    </template>

    <template #fallback>Loading...</template>
  </Suspense>
</template>
